(function () {'use strict';}());
angular.module("elidb").directive('searchbarView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/searchbar.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        $scope.expandTopFilters = false;

        $scope.$watch("currentPage",onPageChange);

        
        $scope.toggleTopFilters = function(){
      		$scope.expandTopFilters = !$scope.expandTopFilters;
          $scope.containerClasses.filters = $scope.expandTopFilters;
      		if($scope.expandTopFilters) $document.on("keydown",onKeyDown);
      		else $document.off("keydown",onKeyDown);

          if($scope.currentPage === $scope.FEATURE_PAGE){
            if($scope.expandTopFilters) $(".main-footer, .footer-copyright, .feature-container").hide();
            else $(".main-footer, .footer-copyright, .feature-container").show();
          }
   		 };


       function onPageChange(val){
          if($scope.mobile && val === $scope.RESULTS_MAIN_PAGE) return;
          if($scope.expandTopFilters)  $scope.toggleTopFilters();
          if(val === $scope.RESULTS_MAIN_PAGE && !$scope.expandTopFilters){
            $scope.toggleTopFilters();
          }
       }

   		function onKeyDown(e){
  			if(e.keyCode === 27) $scope.$apply($scope.toggleTopFilters);
  		}
      }  
    };
  });